import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Master Setting", route: "/admin/master-setting/position-master" },
  { name: "Position Master", route: "/admin/master-setting/position-master" },
  { name: "View Position" },
];

const CandidateMangementPositionView = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const positionInfo = state?.positionInfo;

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="View Position">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate("/admin/candidate-management/view", { ...state })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={6} marginBottom={4}>
              <Typography variant="body1">Position Name</Typography>
              <Typography variant="subtitle2">
                {state?.positionData?.position_id?.name || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Position Level</Typography>
              <Typography variant="subtitle2">
                {state?.positionData?.position_id?.level || "NA"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} marginBottom={4}>
              <Typography variant="body1">Description</Typography>
              <Typography variant="subtitle2">
                {state?.positionData?.description || "NA"}
              </Typography>
            </Grid>
            <Grid item xs={3} marginBottom={4}>
              <Typography variant="body1">Domain Specialisation</Typography>
              <Typography variant="subtitle2">
                {positionInfo?.domains
                  ?.map((val: any) => val?.domain_id?.name)
                  .join(", ") || "NA"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </PageWrapper>
  );
};
export default CandidateMangementPositionView;
